import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../AuthContext";
import Auth from "./Auth";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
    <div className="w-10 h-10 rounded-full border-2 border-[#3F6E85] border-t-transparent animate-spin" />
  </div>
);

export default function TenantOnboarding() {
  const { slug } = useParams();
  const { user, loading } = useAuth();
  const [tenant, setTenant] = useState(undefined); // undefined = loading, null = not found

  useEffect(() => {
    let active = true;
    api
      .get(`/tenants/${slug}`)
      .then((r) => active && setTenant(r.data))
      .catch(() => active && setTenant(null));
    return () => { active = false; };
  }, [slug]);

  if (loading || tenant === undefined) return <Loader />;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  if (tenant === null) return <Navigate to="/" replace />;

  return <Auth mode="register" tenant={tenant} />;
}
